import { FEATURE_FLAGS } from '~/constants';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';

import { InviteCreatorEmptyMockResults } from './InviteCreatorEmptyMockResults';
import { InviteCreatorEmptyResults } from './InviteCreatorEmptyResults';

export const InviteCreatorEmptyPage: React.FC = () => {
  const foamEmptyTalentPageFlag =
    useFeatureFlag(FEATURE_FLAGS.foamTalentEmptyState) === 'enabled';

  return (
    <>
      {foamEmptyTalentPageFlag ? (
        <InviteCreatorEmptyMockResults />
      ) : (
        <InviteCreatorEmptyResults />
      )}
    </>
  );
};
